import { replaceSpeciesNamesEn } from 'common/utils/species'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

// ----------------------------------------------------------------------

// Browser language is only used to pick Burmese automatically. English is
// opt-in from settings: many Thai users run an English browser and should
// still get Thai by default.
const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'navigatorMy',
  lookup: () =>
    (navigator.languages ?? [navigator.language]).some((lng) => lng?.startsWith('my'))
      ? 'my'
      : undefined,
})

// Species names from the backend are Thai; swap them in English output.
const speciesNameEn = {
  type: 'postProcessor' as const,
  name: 'speciesNameEn',
  process: (value: string, _key: string | string[], _options: unknown, translator: { language?: string }) =>
    translator.language?.startsWith('en')
      ? replaceSpeciesNamesEn(value)
      : value,
}

i18n
  .use(speciesNameEn)
  .use(languageDetector)
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'th',
    supportedLngs: ['th', 'my', 'en'],
    postProcess: ['speciesNameEn'],
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigatorMy'],
    },
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false,
    },
    // react-i18next options
    react: {
      useSuspense: false,
    },
  })

// dayjs month/day names follow the UI language (was always Thai).
const syncDayjsLocale = (lng?: string) => dayjs.locale(lng?.startsWith('en') ? 'en' : 'th')
syncDayjsLocale(i18n.language)
i18n.on('languageChanged', syncDayjsLocale)

export default i18n
